import {createRouter, createWebHistory} from "vue-router";
import defaultRoutes from "@/modules/default/routes"
import citizenRoutes from "@/modules/citizen/routes"
import publicRoutes from "@/modules/public/routes"
import boardRoutes from "@/modules/board/routes"
import urbanPlannerRoutes from "@/modules/urban-planner/routes"
import mobileRoutes from "@/modules/mobile/routes"
import syncmapMobileRoutes from "@/modules/syncmap/routes"
import publicAppRoutes from "@/modules/public-app/routes"
import {config} from "@/config/config";

const routes =
  config.APP_TYPE === 'citizen' ? citizenRoutes
    : config.APP_TYPE === 'public' ? publicRoutes
    : config.APP_TYPE === 'board' ? boardRoutes
    : config.APP_TYPE === 'urban-planner' ? urbanPlannerRoutes
    : config.APP_TYPE === 'mobile' ? mobileRoutes
    : config.APP_TYPE === 'syncmap' ? syncmapMobileRoutes
    : config.APP_TYPE === 'public-app' ? publicAppRoutes
      : defaultRoutes;

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return {left: 0, top: 0};
  },
});

export default router;
